export default __webpack_public_path__ + "static/media/img-home-first.c093e441.png";